import { z } from "zod";

import { WorkStyleType } from "@/data/consultant-profiles/types/WorkStyleType";

export const WorkStyle = z
  .object({
    type: WorkStyleType,
    score: z.number(),
  })
  .passthrough();

export type WorkStyle = z.infer<typeof WorkStyle>;
